module.exports = __webpack_public_path__ + "e35a4d41b04c752fa18417387de291ba.MP3";